// WASM module types are declared in wasm.d.ts

// -- Application types --

export type PaintMode = 'paint' | 'erase';
export type NodeType = 'smooth' | 'free';

export interface SmNode {
  x: number;
  y: number;
  type: NodeType;
}

export interface MultiGroupItem {
  path: string;
  seedX: number;
  seedY: number;
  sourceColor: string;
}

export interface StashSubPath {
  path: string;
  sourceColor: string;
}

export interface StashItem {
  id: string;
  name: string;
  path: string | null;
  color: string;
  sourceColor: string;
  include?: boolean;
  visible: boolean;
  groupPaths?: StashSubPath[];
}

export interface SliderConfig {
  el: HTMLInputElement;
  val: HTMLElement;
  fmt: (v: string) => string;
}

export interface GaSliderConfig {
  el: HTMLInputElement;
  val: HTMLElement;
  fmt: (v: string) => string;
}

export interface SavedState {
  seedX: number | null;
  seedY: number | null;
  stash: StashItem[];
  stashCounter: number;
  tolerance: string;
  margin: string;
  rdp: string;
  segments: string;
  opacity: string;
  overlayColor: string;
  shapeHint: string;
  noHoles: boolean;
  gaPenalty: string;
  gaOvershoot: string;
  gaPop: string;
  gaGen: string;
  overlayMode: boolean;
}

export interface RestoredImage {
  file: File;
  rgba: Uint8ClampedArray;
  imgW: number;
  imgH: number;
}

export interface ImageCoords {
  x: number;
  y: number;
}

export const DEFAULTS = {
  tolerance: 30, margin: 0, rdpEpsilon: 2, segments: 16,
  overlayOpacity: 0.5, overlayColor: '#66ccff', shapeHint: '2',
  noHoles: false, gaPenalty: 5, gaOvershoot: 20, gaPop: 30, gaGen: 30,
} as const;
